var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"profile-avatar"},[_c('img',{style:({height: _vm.calSize + 'px', width: _vm.calSize + 'px'}),attrs:{"src":_vm.displayImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }